import * as z from "zod";

export const getShopperAgentEmbeddingBackfillFleet = {
  name: "getShopperAgentEmbeddingBackfillFleet" as const,
  input: z.object({}),
  output: z.object({
    merchants: z.array(
      z.object({
        teamId: z.string(),
        teamName: z.string(),
        status: z.enum(["none", "running", "completed", "failed"]),
        startedAt: z.date().nullable(),
        completedAt: z.date().nullable(),
      }),
    ),
  }),
};
